import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useFeatureFlag } from 'modules/common/hooks';
import { useNotesBackgroudTimerContext } from 'modules/NotesBackgroudTimer/context/NotesBackgroudTimerContext';
import { NOTE_FIELDS } from '../../noteSchema';

export default function useInlineTimerActive() {
  const { control } = useFormContext();
  const noteId = useWatch({ name: NOTE_FIELDS.NOTE_ID, control });
  const {
    running,
    signalId,
    getCurrentInlineTimerDuration
  } = useNotesBackgroudTimerContext();
  const isTiwInlineTimerEnabled: boolean = useFeatureFlag(
    'isTiwInlineTimerEnabled',
    false
  );
  const isInlineTimerActive = useMemo(() => {
    return isTiwInlineTimerEnabled && running && signalId;
  }, [isTiwInlineTimerEnabled, running, signalId]);

  const isInlineTimeActiveOnThisNote = useMemo(() => {
    return signalId === noteId;
  }, [noteId, signalId]);

  const disabledByInlineTimer = useMemo(() => {
    return isInlineTimerActive && !isInlineTimeActiveOnThisNote;
  }, [isInlineTimerActive, isInlineTimeActiveOnThisNote]);

  const isInlineTimerRunning = useMemo(() => {
    return isInlineTimerActive && isInlineTimeActiveOnThisNote;
  }, [isInlineTimerActive, isInlineTimeActiveOnThisNote]);

  return useMemo(
    () => ({
      disabledByInlineTimer,
      isInlineTimerRunning,
      inlineTimerDuration: getCurrentInlineTimerDuration()
    }),
    [disabledByInlineTimer, isInlineTimerRunning, getCurrentInlineTimerDuration]
  );
}
